import { DashboardConstants } from '../../actions/constant';

const {
  GET_DASHBOARD_TIME_IN_RESET,
  GET_DASHBOARD_TIME_IN_SUCCESS,
  GET_DASHBOARD_TIME_IN_FAILURE,
  GET_DASHBOARD_TIME_IN_LOADER,
  RESET_HARD_CLOCK_IN,
} = DashboardConstants;
const intitialstate: object = {
  response: null,
  isGetCheckIn: false,
  withPersistResponse: null,
  loading: false,
};

export const checkInReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_DASHBOARD_TIME_IN_SUCCESS: {
      return {
        ...state,
        isGetCheckIn: true,
        response: action.payload,
        withPersistResponse: action.payload,
        loading: false,
      };
    }

    case GET_DASHBOARD_TIME_IN_FAILURE:
      return {
        ...state,
        isGetCheckIn: false,
        response: action.payload,
        withPersistResponse: action.payload,
        loading: false,
      };

    case GET_DASHBOARD_TIME_IN_LOADER:
      return {
        ...state,
        loading: true,
      };

    case GET_DASHBOARD_TIME_IN_RESET:
      return {
        ...state,
        response: null,
        isGetCheckIn: false,
        loading: false,
      };

    case RESET_HARD_CLOCK_IN:
      return intitialstate;

    default:
      return state;
  }
};
